const config = {
    // apiUrl: 'http://192.168.1.10:8080',

    // apiUrl: 'http://localhost:8080',

    apiUrl: 'https://btt.org.pl/api',
};

export default config;
